import {
  NotificationPreference,
  ContactParams,
  DigestFrequency,
  ChatNotificationPreference
} from '../../../libs/contact';
import { GetCurrentTZ } from '../../../libs/time';

export enum AlertMode {
  AllTimes = 'all',
  BusinessHourOnly = 'bh_only'
}

export enum AlertDigestFrequency {
  Off = 'O',
  Daily = 'D',
  Tridaily = 'T',
  Weekly = 'W'
}

export enum ReportDigestFrequency {
  Off = 'O',
  Daily = 'D',
  Tridaily = 'T',
  Weekly = 'W',
  Biweekly = 'B'
}

export enum ChatDigestFrequency {
  Off = 'O',
  Daily = 'D',
  Tridaily = 'T',
  Weekly = 'W'
}

export interface ContactCCData {
  id?: number;
  isEmail: boolean;
  email?: string;
  copyId?: number;
}

export interface AfterHoursMessages {
  [key: string]: string[]; // Fixes TypeScript error
  alert: string[];
  chat: string[];
}

export interface ContactData {
  id?: number;
  displayName: string;
  description?: string;
  email?: string;
  primaryPhone: string;
  primaryExtension?: string;
  primaryAllDay: boolean;
  primaryStartTime?: string;
  primaryEndTime?: string;
  primaryDays?: number[];
  offHourPhone?: string;
  offHourExtension?: string;
  afterHoursMessages?: AfterHoursMessages;
  alertMode?: AlertMode;
  alertPhone?: string;
  alertExtension?: string;
  notificationPreference: NotificationPreference;
  chatNotificationPreference: ChatNotificationPreference;
  alertDigestFrequency?: string;
  reportDigestFrequency?: string;
  chatDigestFrequency?: string;
  tz: string;
  npi?: string;
  tags?: string;
  ccs?: Array<{
    id?: number;
    isEmail: boolean;
    email?: string;
    copyId?: number;
  }>;
  isOnVacation?: boolean;
  backupId?: number;
  vacation?: string; //JSON string
  isUsingBackup?: boolean;
  vacationStartDate?: string;
  vacationEndDate?: string;
  cancelVacation?: boolean;
}

export const DefaultContactParams: ContactParams = {
  id: null,
  displayName: '',
  description: '',
  email: '',
  primaryPhone: '',
  primaryExtension: '',
  primaryStartHour: 9,
  primaryStartMinute: 0,
  primaryEndHour: 18,
  primaryEndMinute: 0,
  primaryDays: '1,2,3,4,5',
  offHourPhone: '',
  offHourExtension: '',
  afterHoursMessages: { alert: [''], chat: [''] },
  alertDays: null,
  alertPhone: '',
  alertExtension: '',
  alertStartHour: null,
  alertStartMinute: null,
  alertEndHour: null,
  alertEndMinute: null,
  notificationPreference: NotificationPreference.Email,
  chatNotificationPreference: ChatNotificationPreference.Off,
  alertDigestFrequency: DigestFrequency.Off,
  reportDigestFrequency: DigestFrequency.Weekly,
  tz: GetCurrentTZ(),
  npi: '',
  tags: '',
  ccs: [],
  backupId: null,
  vacationStartDate: null,
  vacationEndDate: null,
  cancelVacation: false
};
